import { initialState } from '../reducers/tools/decisionTree/checkOrderDate';
import { createSelector } from 'reselect';

const checkOrderDate = (state) => state.tools.decisionTree.checkOrderDate || initialState;

const selectError = createSelector(checkOrderDate, (state) => state.error);

const isGotHereByBackButton = createSelector(checkOrderDate, (state) => state.gotHereByBackButton);

export { selectError, isGotHereByBackButton };
